module.exports = __webpack_public_path__ + "img/obs_swstg_normal.3e234167.svg";